<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">{{ cafeName }} 카페의 상세정보</div>
                    <div class="tab_content" v-if="tabIdx === 1">
                        <board-write-component :boardType="`cafeConfigUpdate`" :boardKey ="cafeKey"></board-write-component>
                        <div class="text-center mt15">
                            <el-button type="primary" @click="save">저장</el-button>
                            <el-button @click="$router.back()">목록</el-button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
    import BoardWriteComponent from "@/components/board/BoardWriteComponent";
    export default {
        name: 'CafeConfigDetail',
        components: {
            BoardWriteComponent
        },
        mixins: [  ],
        data() {
            return{
                tabIdx: 1,
                cafeKey: Number(this.$route.params.c_idx),
                cafeName:''
            }
        },
        mounted() {
            EventBus.$on('CafeDetailSetData',this.setData)
        },
        beforeDestroy() {
            EventBus.$off('CafeDetailSetData')
        },
        watch: {
        },
        created() {
        },
        methods: {
            setData(key,value){
                this[key] = value
            },
            save() {
                EventBus.$emit('writeBoard')
            },
            changeTab(num) {
                this.$router.replace(this.$route.path);
                this.tabIdx = num;
            },
        }
    }
</script>
